import React from 'react';
import { SelectInput, Create, TabbedForm, FormTab, TabbedShowLayout, Tab, Show, ShowButton, BooleanField, TextInput, LongTextInput, List, Edit, Datagrid, TextField, EditButton } from 'react-admin';
import { isAdmin } from "./authProvider";

const roles = [
  { id: 'admin', name: 'Admin' },
  { id: 'application', name: 'Application' },
  { id: 'user', name: 'User' }
];

export const UserList = ({permissions, ...props}) => (
  <List {...props} bulkActions={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="email" />
      <TextField source="domain" />
      <BooleanField source="is_admin" />
      <ShowButton />
      {isAdmin(permissions) && <EditButton />}
    </Datagrid>
  </List>
);

export const UserShow = (props) => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Identity">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="email" />
        <TextField source="key" />
      </Tab>
      <Tab label="Application">
        <TextField source="domain" />
        <TextField source="callback_url" />
        <TextField source="support_url" />
        <TextField source="logo_url" />
        <TextField source="primary_color" />
      </Tab>
      <Tab label="Permissions">
        <TextField source="role" />
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const UserCreate = (props) => (
  <Create title={props.uuid} {...props}>
    <TabbedForm>
      <FormTab label="Identity">
        <TextInput source="name" />
        <TextInput source="email" />
      </FormTab>
      <FormTab label="Application">
        <TextInput source="domain" />
        <TextInput source="callback_url" />
        <TextInput source="support_url" />
        <TextInput source="logo_url" />
        <TextInput source="primary_color" />
      </FormTab>
      <FormTab label="Permissions">
        <SelectInput source="role" choices={roles} />
      </FormTab>
    </TabbedForm>
  </Create>
);

export const UserEdit = (props) => (
  <Edit title={props.uuid} {...props}>
    <TabbedForm>
      <FormTab label="Identity">
        <TextField source="id" />
        <TextInput source="name" />
        <TextInput source="email" />
        <TextInput source="key" />
        <LongTextInput source="secret" />
      </FormTab>
      <FormTab label="Application">
        <TextInput source="domain" />
        <TextInput source="callback_url" />
        <TextInput source="support_url" />
        <TextInput source="logo_url" />
        <TextInput source="primary_color" />
      </FormTab>
      <FormTab label="Permissions">
        <SelectInput source="role" choices={roles} />
      </FormTab>
    </TabbedForm>
  </Edit>
);


// WEBPACK FOOTER //
// ./resources/assets/js/user.js